let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6mHDm")).then(() => parcelRequire('2wMV7'));